export default __webpack_public_path__ + "static/media/landingHeroImage.60ab887e.png";